export enum TutorialUpdateScope {
  Following = 'following',
  All = 'all',
}

export enum TutorialFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Fortnightly = 'fortnightly',
}
